(function () {
  var KLAVIYO_TOKEN = 'Qe5p3Y';
  // Klaviyo's client-side Events API is CORS-enabled for in-browser use with the
  // public company id. The legacy /api/track endpoint rejects the JSON preflight.
  var KLAVIYO_EVENTS_URL = 'https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_TOKEN;
  var KLAVIYO_REVISION = '2024-10-15';
  var REQUEST_TIMEOUT_MS = 15000;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var section = document.querySelector('[data-withdrawal-section]');
    if (!section) return;

    var form = section.querySelector('[data-withdrawal-form]');
    var submitBtn = section.querySelector('[data-submit]');
    var successBox = section.querySelector('[data-success]');
    var formErrorBox = section.querySelector('[data-form-error]');
    if (!form) return;

    var submitLabel = submitBtn ? submitBtn.textContent : '';

    function showFieldError(name, message) {
      var el = form.querySelector('[data-error-for="' + name + '"]');
      if (el) {
        el.textContent = message;
        el.hidden = false;
      }
      var input = form.querySelector('[name="' + name + '"]');
      if (input) input.setAttribute('aria-invalid', 'true');
    }

    function clearErrors() {
      var errs = form.querySelectorAll('[data-error-for]');
      for (var i = 0; i < errs.length; i++) {
        errs[i].textContent = '';
        errs[i].hidden = true;
      }
      var inputs = form.querySelectorAll('[aria-invalid]');
      for (var j = 0; j < inputs.length; j++) {
        inputs[j].removeAttribute('aria-invalid');
      }
      if (formErrorBox) formErrorBox.hidden = true;
    }

    var firstInvalidField = null;

    function markInvalid(name, message) {
      showFieldError(name, message);
      if (!firstInvalidField) firstInvalidField = name;
    }

    function validate(values) {
      firstInvalidField = null;
      if (!values.name) {
        markInvalid('name', 'Please enter your full name.');
      }
      if (!values.email) {
        markInvalid('email', 'Please enter your email address.');
      } else if (!EMAIL_RE.test(values.email)) {
        markInvalid('email', 'Please enter a valid email address.');
      }
      if (!values.order_number) {
        markInvalid('order_number', 'Please enter your order number.');
      }
      return !firstInvalidField;
    }

    function focusFirstInvalid() {
      if (!firstInvalidField) return;
      var input = form.querySelector('[name="' + firstInvalidField + '"]');
      if (input && input.focus) input.focus();
    }

    function setPending(isPending) {
      if (!submitBtn) return;
      submitBtn.disabled = isPending;
      submitBtn.setAttribute('aria-busy', isPending ? 'true' : 'false');
      submitBtn.textContent = isPending ? 'Submitting…' : submitLabel;
    }

    function showSuccess() {
      form.hidden = true;
      if (formErrorBox) formErrorBox.hidden = true;
      if (successBox) {
        successBox.hidden = false;
        successBox.setAttribute('tabindex', '-1');
        successBox.focus();
      }
    }

    function showFormError() {
      setPending(false);
      if (formErrorBox) {
        formErrorBox.hidden = false;
        formErrorBox.setAttribute('tabindex', '-1');
        formErrorBox.focus();
      }
    }

    function readValue(name) {
      var input = form.querySelector('[name="' + name + '"]');
      return input && input.value ? input.value.trim() : '';
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearErrors();

      var values = {
        name: readValue('name'),
        email: readValue('email'),
        order_number: readValue('order_number')
      };

      if (!validate(values)) {
        focusFirstInvalid();
        return;
      }

      setPending(true);

      var payload = {
        data: {
          type: 'event',
          attributes: {
            properties: {
              name: values.name,
              email: values.email,
              order_number: values.order_number,
              country: form.getAttribute('data-country') || '',
              locale: form.getAttribute('data-locale') || '',
              submitted_at: new Date().toISOString(),
              source_url: window.location.href
            },
            metric: {
              data: {
                type: 'metric',
                attributes: { name: 'Withdrawal Requested' }
              }
            },
            profile: {
              data: {
                type: 'profile',
                attributes: { email: values.email }
              }
            }
          }
        }
      };

      var controller = new AbortController();
      var timeoutId = setTimeout(function () {
        controller.abort();
      }, REQUEST_TIMEOUT_MS);

      fetch(KLAVIYO_EVENTS_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: KLAVIYO_REVISION
        },
        body: JSON.stringify(payload),
        signal: controller.signal
      })
        .then(function (res) {
          clearTimeout(timeoutId);
          // The client Events API returns 202 Accepted (empty body) on success.
          if (!res.ok) throw new Error('Klaviyo event failed: ' + res.status);
          showSuccess();
        })
        .catch(function (err) {
          clearTimeout(timeoutId);
          if (window.console && console.error) console.error(err);
          showFormError();
        });
    });
  });
})();
